const favourite_holiday  = `Yksi Suomen suosituimmista juhlapäivistä on joulu.
Se on erityistä aikaa, kun perheet ja ystävät kokoontuvat juhlimaan ja viettämään aikaa toistensa kanssa.
Joulun aikaan ihmiset koristelevat kotinsa valoilla, puilla ja koristeilla.
He myös vaihtavat lahjoja keskenään ja nauttivat herkullisesta ruoasta, kuten kinkusta, kalasta ja piparkakuista.
Perheet käyvät usein yhdessä saunassa ja nauttivat lämmöstä kylminä talvipäivinä.
Jotkut ihmiset käyvät myös kirkossa juhlimassa juhlaa ja muistamassa sen merkitystä.
Yksi joulun erityispiirteistä Suomessa on joulupukin perinne,
jonka uskotaan tuovan lahjoja lapsille jouluaattona.
Monet perheet jättävät kulhollisen puuroa joulupukille nautittavaksi, kun tämä vierailee heidän kotonaan.
Kaiken kaikkiaan joulu on iloista ja juhlavaa aikaa Suomessa, täynnä rakkautta, lämpöä ja yhdessäoloa.
Se on aikaa, jolloin ihmiset kokoontuvat jakamaan onnea ja luomaan kestäviä muistoja rakkaittensa kanssa.`;

export default favourite_holiday;